import React, { useState } from 'react';
import './header.css';
import Nav_links from '../comman/Nav_links';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <header>
            <h4 className='logo'>PrestigeEstate</h4>

            <nav className="nav">
                <ul className="nav__list">
                    <Nav_links text="Home"       to="/" />
                    <Nav_links text="Properties" to="/properties" />
                    <Nav_links text="About us"   to="" />
                    <Nav_links text="Contact us" to="" />
                </ul>
            </nav>

            <div className="burger" onClick={() => setMenuOpen(!menuOpen)}>
                <span className="burger__line" />
                <span className="burger__line" />
                <span className="burger__line" />
            </div>

            {menuOpen && (
                <ul className="mobile__list">
                    <Nav_links text="Home"to="/" />
                    <Nav_links text="Properties"to="/properties" />
                    <Nav_links text="About us" to="" />
                    <Nav_links text="Contact us" to="" />
                </ul>
            )}
        </header>
    );
};

export default Header;